module.exports = __webpack_public_path__ + "sh.svg?23f8c52d52e7960d1d4d2def69ec3543";